import { render, staticRenderFns } from "./provider-card.vue?vue&type=template&id=5fe2bb03&scoped=true&"
import script from "./provider-card.vue?vue&type=script&lang=js&"
export * from "./provider-card.vue?vue&type=script&lang=js&"
import style0 from "./provider-card.vue?vue&type=style&index=0&id=5fe2bb03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe2bb03",
  null
  
)

export default component.exports